import React, {useContext} from "react";
import {Field} from "react-final-form";
import MuiButton from "@material-ui/core/Button";

// import Participents from "./Participents";
// import Invoicedata from "./Invoicedata";
// import TotalSum from "./TotalSum";
// import TicketSelect from "./TicketSelect";
// import Checkbox from "./Checkbox";
// import RadioButtonSmall from "./RadioButtonSmall";
// import RadioButton from "./RadioButton";
import Select from "./Select";
import TextInput from "./TextInput";
import RadioBig from "./RadioBig";
import Checkbox from "./Checkbox";
import ProductSelect from "./ProductSelect";
import AddressSelect from "./AddressSelect";
import SerialNumber from "./SerialNumber";
import RequesttypeSelect from "./RequesttypeSelect";
import {useInertiaState} from "./Layout";
import Datepicker from "./Datepicker";
import TimeSlots from "./TimeSlots";
// import LoginLink from "./LoginLink";
import { Trans } from "../utils/i18n";
import AppointmenttypeSelect from "./AppointmenttypeSelect";
import DropzoneForm from "./DropzoneForm";
import ValidateAddress from "./ValidateAddress";
import AddressAutocomplete from "./AddressAutocomplete";
import ProblemSelect from "./ProblemSelect";
import ProblemSelectNiu from "./ProblemSelectNiu";
import MetaPicker from "./MetaPicker";
import ParcelServiceSelect from "./ParcelServiceSelect";
import SerialNumberReturnService from "./SerialNumberReturnService";
import DateTimepicker from "./DateTimepicker";
import {ProductDropdown} from "../FormComponents/ProductDropdown";
import QueueDetailDropzone from "./QueueDetailDropzone";
import StatusSelect from "../FormComponents/StatusSelect";
import PartnerSelect from "./PartnerSelect";
import {getCookieValue} from "../utils/getCookieValue";
import { Button } from "./Button";
import ProblemSelectBig from "./ProblemSelectBig";
import VerifyPhoneNumber from "../FormComponents/VerifyPhoneNumber";
import {DeviceWidget} from "../FormComponents/DeviceWidget/DeviceWidget";
import Radio from "./Radio";
import PhoneInput from "../FormComponents/PhoneInput";
import {ProductSelectWithAmount} from "./ProductSelectWithAmount";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import {usePage} from "@inertiajs/inertia-react";
import {ProductSelectDynamic} from "./ProductSelectDynamic";
import {ProductSelectManual} from "./ProductSelectManual";
import {ProductConfig} from "./ProductConfig";
import SelfRepairInstructions from "../FormComponents/SelfRepair/SelfRepairInstructions";
import {SelfRepairProductSelect} from "../FormComponents/SelfRepair/SelfRepairProductSelect";
import ShippingBox from "./ShippingBox";
import {ProductCategorySelect} from "./ProductCategorySelect";
import ConfirmDevice from "./ConfirmDevice";
import TerminalID from "./TerminalID";
import {SerialnumberDynamic} from "./SerialnumberDynamic";
import AmazonLockerWidget from "../FormComponents/AmazonLockerWidget";
import EnterOrderDetails from "../FormComponents/ReturnOrder/EnterOrderDetails";
import SelectReturnItems from "../FormComponents/ReturnOrder/SelectReturnItems";
import { ProductCategoryProductSelect } from "./ProductCategoryProductSelect";
import { PurchaseDateSelect } from "./PurchaseDateSelect";
import {SerialnumberDynamicWithoutProductSelect} from "./SerialnumberDynamicWithoutProductSelect";
import WorkflowQuestions from "../FormComponents/Workflow/WorkflowQuestions";
import { ModelGroupSelector } from "../FormComponents/ProductConfigurator/ModelGroupSelector";
import { VariantSelector } from "../FormComponents/ProductConfigurator/VariantSelector";
import { CategorySelector } from "../FormComponents/ProductConfigurator/CategorySelector";
import { ProductSelector } from "../FormComponents/ProductConfigurator/ProductSelector";
import { SelfRepairGuidesList } from "./SelfRepairGuidesList";
import { ProductsTable } from "../FormComponents/POC/ProductsTable";
import { AutocompleteField, AutocompleteQueryField } from "./Fields/AutocompleteField";
import { omit } from "lodash";
import { useEventBus } from "../stores/EventBusProvider";
import { useQueryClient } from "@tanstack/react-query";
import { DeviceWidgetB2B } from "../FormComponents/DeviceWidget/DeviceWidgetB2B";
import EmptyBoxCheckbox from "../FormComponents/EmptyBoxCheckbox";
import { ShoppingCartField } from "./ShoppingCartField";

export const validateEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const validateDateRegEx = /^\d\d\.\d\d\.\d\d\d\d$/;
export const validateVinRegEx = /^(19924\d{10}|200\d{12})$/;
export const validateTidRegEx = /^(440\d{5}|540\d{5}|541\d{5}|542\d{5}|543\d{5}|545\d{5}|750\d{5}|752\d{5}|753\d{5})$/;
export const validateUpsLabelRegEx = /^.{1,35}$/;
export const validateUpsLabelZipRegEx = /^\d{4,5}$/;
export const validateUpsLabelZipRegExDe = /^\d{5}$/;
export const validateUpsLabelZipRegExAt = /^\d{4}$/;
export const validateUpsLabelPhoneRegEx = /^(\+?([0-9\-\s]{0,15})|([0-9\-\s]{0,16}))$/;
export const validateFiservSerialNumber = /^.{0,100}$/;
export const validateTerminalIdWorldpay = /^.\d{7}$/;
export const validateMID = /^\d{8}$/;
export const validateServiceCodeAmazonLocker = /^.\d{8}$/;
export const validatePhoneNumber = /^(\+\d{1,3})\s?.{4,}$/;
export const validateMax200Chars = /^[\s\S]{0,200}$/;

export const array = {};
const simpleMemoize = (fn, country_id) => {

    return (arg) => {
        const key = arg + '-' + country_id;
        if (array[key]) {
            return array[key];
        }
        array[key] = fn(arg);
        return array[key];
    };
};

const validate = {
    'email': value => value ? validateEmailRegEx.test(value) ? undefined : <Trans i18nKey="formField.emailAddressIsRequired">Email address is required</Trans> : <Trans i18nKey="formField.required">Required</Trans>,
    'datepicker': value => value ? validateDateRegEx.test(value) ? undefined : <Trans i18nKey="formField.enterAValidDatePlease">Enter a valid date please</Trans> : <Trans i18nKey="formField.required">Required</Trans>,
    'vin': value => value ? validateVinRegEx.test(value) ? undefined : <Trans i18nKey="formField.enterAValidVin">Please enter a valid VIN number in the format 19924xxxxxxxxxx or 200xxxxxxxxxxxx</Trans> : <Trans i18nKey="formField.required">Required</Trans>,
    'tid': value => value ? validateTidRegEx.test(value) ? undefined : <Trans i18nKey="formField.enterAValidTid">Die von Ihnen eingegebene Terminal-ID ist uns nicht bekannt oder ist für einen anderen Austauschprozess vorgesehen. Bitte überprüfen Sie Ihre Eingabe und versuchen es erneut. Sollten Sie die Terminal-ID korrekt eingegeben haben, wenden Sie sich für weitere Hilfe bitte direkt an partnerservice@fiserv.com. Vielen Dank!</Trans> : <Trans i18nKey="formField.required">Required</Trans>,
    'upslabel': value => value ? validateUpsLabelRegEx.test(value) ? undefined : <Trans i18nKey="formField.enter35chars">Bitte geben Sie maximal 35 Zeichen ein</Trans> : <Trans i18nKey="formField.required">Required</Trans>,
    'upslabelzip': value => value ? validateUpsLabelZipRegEx.test(value) ? undefined : <Trans i18nKey="formField.enter35chars">Bitte geben Sie 4 (Österreich) oder 5 (Deutschland) Ziffern ein</Trans> : <Trans i18nKey="formField.required">Required</Trans>,
    'upslabelzipDe': value => value ? validateUpsLabelZipRegExDe.test(value) ? undefined : <Trans i18nKey="formField.enter35chars">Bitte geben Sie 5 Ziffern ein</Trans> : <Trans i18nKey="formField.required">Required</Trans>,
    'upslabelzipAt': value => value ? validateUpsLabelZipRegExAt.test(value) ? undefined : <Trans i18nKey="formField.enter35chars">Bitte geben Sie 4 Ziffern ein</Trans> : <Trans i18nKey="formField.required">Required</Trans>,
    'upslabelphone': value => value ? validateUpsLabelPhoneRegEx.test(value) ? undefined : <Trans i18nKey="formField.upslabelphone">Bitte geben Sie maximal 16 Ziffern ein z.B. +49123456789</Trans> : '',
    'fiservserialnumber': value => value ? validateFiservSerialNumber.test(value) ? undefined : <Trans i18nKey="formField.fiservserialnumber">Bitte geben Sie maximal 100 Zeichen ein</Trans> : undefined,
    'phoneinput': value => value ? validatePhoneNumber.test(value) ? undefined : <Trans i18nKey="formField.phone">Please type in a phone number in the format +442223232322</Trans> : <Trans i18nKey="formField.required">Required</Trans>,
    'terminalIdWorldpay': value => value ? validateTerminalIdWorldpay.test(value) ? undefined : <Trans i18nKey="formField.terminalIdWorldpay">Bitte geben Sie genau 8 Zeichen ein</Trans> : undefined,
    'mid': value => value ? validateMID.test(value) ? undefined : <Trans i18nKey="formField.validateMID">Please enter exactly 8 digits</Trans> : undefined,
    'serviceCodeAmazonLocker': value => value ? validateServiceCodeAmazonLocker.test(value) ? undefined : <Trans i18nKey="formField.serviceCodeAmazonLocker">You have to provide exactly 9 digits</Trans> : undefined,
    'max200chars': value => value ? validateMax200Chars.test(value) ? undefined : <Trans i18nKey="formField.max200chars">Please enter a maximum of 200 characters</Trans> : undefined,
};
const required = value => (value ? undefined : <Trans i18nKey="formField.required">Required</Trans>);

const FormField = React.memo(function ({ disabled, field, preFix, participentKey, submitting, values, mutators, requesttypes, form, onClick, nextStep, isOrderable }) {
    const { countries, currentCountry, parcel_services } = usePage().props;
    const orderEntryState = useFormState();
    const orderEntryDispatch = useFormStateDispatch();
    const { send } = useEventBus();
    const { serialNumber } = orderEntryState;
    const queryClient = useQueryClient();

    const name = preFix ? preFix + '[' + participentKey + '][' + field.name + ']' : field.name;

    switch(field.component) {
        case 'link':
            return (
                <MuiButton
                    variant="contained"
                    color="primary"
                    href={field.href}
                >
                    { field.title }
                </MuiButton>
            );
        case 'button':
            return (
                <Button field={field} onClick={onClick}>
                    { field.text }
                </Button>
            );
        case 'productselect':
            return (
                <ProductSelect product={values.product} form={form}>
                </ProductSelect>
            );
        case 'productselectwithamount':
            return (
                <ProductSelectWithAmount
                    productValues={values.products}
                    product={values.product}
                    form={form}
                    hideProductDetailsButton={field.hideProductDetailsButton}
                    hideUnavailableContactLink={field.hideUnavailableContactLink}
                >
                </ProductSelectWithAmount>
            );
        case 'selfrepairproductselect':
            return (
                <SelfRepairProductSelect
                    productValues={values.products}
                    product={values.product}
                    form={form}
                    problem_2={values.problem_2}
                    maxQuantity={field.maxQuantity}
                    hideProductDetailsButton={field.hideProductDetailsButton}
                    hideUnavailableContactLink={field.hideUnavailableContactLink}
                >
                </SelfRepairProductSelect>
            );
        case 'shoppingcart':
            return (
                <ShoppingCartField {...omit(field, ['component', 'conditionFunction'])} />
            );
        case 'shippingbox':
            return (
                <ShippingBox
                    values={values}
                    form={form}
                />
            );
        case 'productselectdynamic':
            return (
                <ProductSelectDynamic
                    productValues={values.products}
                    values={values}
                    product={values.product}
                    form={form}
                    mode={field.mode}
                    amountOptions={field.amountOptions}
                >
                </ProductSelectDynamic>
            );
        case 'serialnumberdynamicwithoutproductselect':
            return (
                <SerialnumberDynamicWithoutProductSelect
                    productValues={values.products}
                    values={values}
                    product={values.product}
                    form={form}
                    mode={field.mode}
                    amountOptions={field.amountOptions}
                    disableColorSelection={field.disableColorSelection}
                    validateSerialNumber={field.validateSerialNumber}
                    referenceFieldRequired={field.referenceFieldRequired}
                    displayEmptyBoxCheckbox={field.displayEmptyBoxCheckbox}
                >
                </SerialnumberDynamicWithoutProductSelect>
            );
        case 'serialnumberdynamic':
            return (
                <SerialnumberDynamic
                    productValues={values.products}
                    values={values}
                    product={values.product}
                    form={form}
                    mode={field.mode}
                    amountOptions={field.amountOptions}
                    disableColorSelection={field.disableColorSelection}
                    validateSerialNumber={field.validateSerialNumber}
                    referenceFieldRequired={field.referenceFieldRequired}
                    displayEmptyBoxCheckbox={field.displayEmptyBoxCheckbox}
                >
                </SerialnumberDynamic>
            );
        case 'productcategoryselect':
            return (
                <ProductCategorySelect
                    productValues={values.products}
                    values={values}
                    product={values.product}
                    form={form}
                    mode={field.mode}
                    amountOptions={field.amountOptions}
                    fetchWithProducts={field.fetchWithProducts}
                >
                </ProductCategorySelect>
            );
        case 'productcategoryproductselect':
            return (
                <ProductCategoryProductSelect
                    values={values}
                    form={form}
                    mode={field.mode}
                >
                </ProductCategoryProductSelect>
            );
        case 'purchasedateselect':
            return (
                <PurchaseDateSelect
                    values={values}
                    form={form}
                    mode={field.mode}
                >
                </PurchaseDateSelect>
            );
        case 'productselectmanual':
            return (
                <ProductSelectManual
                    productValues={values.products}
                    values={values}
                    product={values.product}
                    form={form}
                    nextStep={nextStep}
                >
                </ProductSelectManual>
            );
        case "workflowquestions":
            return (
                <WorkflowQuestions
                    form={form}
                    values={values}
                />
            );
        case 'productconfig':
            return (
                <ProductConfig
                    productValues={values.products}
                    values={values}
                    product={values.product}
                    form={form}
                    nextStep={nextStep}
                    isOrderable={field.isOrderable}
                    isForSales={field.isForSales}
                    showSelfRepairGuides={field.showSelfRepairGuides}
                    showOtherAvailableDocuments={field.showOtherAvailableDocuments}
                    maxQuantity={field.maxQuantity}
                    noProblems={field.noProblems}
                    disableColorSelection={field.disableColorSelection}
                    enableVariantSelection={field.enableVariantSelection}
                    columns={field.columns}
                    hideProducts={field.hideProducts}
                    hideProductDetailsButton={field.hideProductDetailsButton}
                    hideUnavailableContactLink={field.hideUnavailableContactLink}
                >
                </ProductConfig>
            );
        case 'amazonlockerwidget':
            return (
                <AmazonLockerWidget
                    locker_service_type={values?.orderattributes?.locker_service_type}
                    form={form}
                />
            );
        case 'verify_phone_number':
            return (
                <VerifyPhoneNumber form={form} values={values}>
                </VerifyPhoneNumber>
            );
        case 'partnerselect':
            return (
                <PartnerSelect partner_id={values.partner_id} appointmentGroup={values.appointmentGroup} form={form}>
                </PartnerSelect>
            );
        case 'addressselect':
            return (
                <AddressSelect company={values.company_id || serialNumber?.order?.company_id} address={values.address} custom_address={values.custom_address} addAddress={mutators.addAddress} addCompany={mutators.addCompany} requesttype={values.requesttype} />
            );
        case 'serialnumber':
            return (
                <SerialNumber nextStep={nextStep} validateSerialNumber={field.validateSerialNumber} values={values} addCompany={mutators.addCompany} addCoverageId={mutators.addCoverageId} setAddressId={mutators.setAddressId} setSerialnumber={mutators.setSerialnumber} setAddress={mutators.setAddress} doNotShowConfirmDevice={field.doNotShowConfirmDevice} uppercase={field.uppercase} shopMode={field.shopMode} onChangeCallback={field.onChangeCallback} />
            );
        case 'terminalid':
            return (
                <TerminalID nextStep={nextStep} form={form} validateSerialNumber={field.validateSerialNumber} values={values} addCompany={mutators.addCompany} addCoverageId={mutators.addCoverageId} setAddressId={mutators.setAddressId} setSerialnumber={mutators.setSerialnumber} setAddress={mutators.setAddress} doNotShowConfirmDevice={field.doNotShowConfirmDevice} uppercase={field.uppercase} />
            );
        case 'confirmdevice':
            return (
                <ConfirmDevice nextStep={nextStep} validateSerialNumber={field.validateSerialNumber} values={values} addCompany={mutators.addCompany} addCoverageId={mutators.addCoverageId} setAddressId={mutators.setAddressId} setSerialnumber={mutators.setSerialnumber} setAddress={mutators.setAddress} uppercase={field.uppercase} />
            );
        case 'serialnumberreturnservice':
            return (
                <SerialNumberReturnService values={values} addCompany={mutators.addCompany} addCoverageId={mutators.addCoverageId} setAddressId={mutators.setAddressId} form={form} />
            );
        case 'problemselect':
            return (
                <ProblemSelect values={values} addCompany={mutators.addCompany} addCoverageId={mutators.addCoverageId} setAddressId={mutators.setAddressId} />
            );
        case 'problemselectniu':
            return (
                <ProblemSelectNiu values={values} addCompany={mutators.addCompany} addCoverageId={mutators.addCoverageId} setAddressId={mutators.setAddressId} form={form}/>
            );
        case 'problemselectbig':
            return (
                <ProblemSelectBig values={values} addCompany={mutators.addCompany} addCoverageId={mutators.addCoverageId} setAddressId={mutators.setAddressId} form={form} hideProblemInput={field.hideProblemInput} warningClassName={field.warningClassName} hideEducationText={field.hideEducationText}/>
            );
        case 'requesttypeselect':
            return (
                <RequesttypeSelect requesttypes={requesttypes} requesttype={values.requesttype} doNotResetForm={field.doNotResetForm} form={form} product={values?.product} problem_2={values?.problem_2} />
            );
        case 'appointmenttypeselect':
            return (
                <AppointmenttypeSelect requesttypes={requesttypes} requesttype={values.requesttype} form={form} />
            );
        case 'parcelserviceselect':
            return (
                <ParcelServiceSelect parcel_services={parcel_services} requesttype={values.parcel_service} form={form} submitting={submitting} />
            );
        case 'timeslots':
            return (
                <TimeSlots
                    day={values.day}
                    appointmentGroup={values.appointmentGroup}
                    value={values.timeslot}
                    parcelService={values.parcel_service}
                    partner_id={values.partner_id}
                    form={form}
                />
            );
        case 'dropzoneform':
            return (
                <DropzoneForm type={field.type} form={form} values={values} />
            );
        case 'queuedetaildropzone':
            return (
                <QueueDetailDropzone enableType={field.enableType}/>
            );
        case 'validateaddress':
            return (
                <ValidateAddress values={values}/>
            );
        case 'devicewidget':
            return (
                <DeviceWidget values={values} style={field.style}/>
            );
        case 'self_repair_instructions':
            return (
                <SelfRepairInstructions values={values} displayFilesOnly={field.displayFilesOnly} />
            );
        case 'addressautocomplete':
            return (
                <AddressAutocomplete values={values} form={form} field={field} />
            );
        case 'enterreturnorderdetails':
            return (
                <EnterOrderDetails values={values} form={form} />
            );
        case 'selectreturnitems':
            return (
                <SelectReturnItems values={values} form={form} isViewMode={field.isViewMode} />
            );
        case 'productcategoryselector':
            return (
                <CategorySelector values={values} form={form} {...omit(field, ['component', 'conditionFunction'])} />
            );
        case 'productmodelgroupselector':
            return (
                <ModelGroupSelector values={values} form={form} {...omit(field, ['component', 'conditionFunction'])} />
            );
        case 'productvariantselector':
            return (
                <VariantSelector values={values} form={form} {...omit(field, ['component', 'conditionFunction'])} />
            );
        case 'productselector':
            return (
                <ProductSelector values={values} form={form} {...omit(field, ['component', 'conditionFunction'])} />
            );
        case 'selfrepairguides':
            return (
                <SelfRepairGuidesList values={values} form={form} {...omit(field, ['component', 'conditionFunction'])} />
            );
        case 'productstable':
            return (
                <ProductsTable values={values} form={form} {...omit(field, ['component', 'conditionFunction'])} />
            );
        case 'autocomplete':
            return (
                <AutocompleteQueryField values={values} form={form} {...omit(field, ['component', 'conditionFunction'])} />
            );
        case 'devicewidgetb2b':
            return (
                <DeviceWidgetB2B values={values} form={form} {...omit(field, ['component', 'conditionFunction'])} />
            );
        case 'emptyboxcheckbox':
            return (
                <EmptyBoxCheckbox values={values} form={form} />
            );
        case 'callback':
            return field.callback(values, orderEntryState, orderEntryDispatch, send, form, queryClient);
        default:
            const component = {
                checkbox: Checkbox,
                radio: Radio,
                radiobig: RadioBig,
                select: Select,
                datepicker: Datepicker,
                datetimepicker: DateTimepicker,
                metapicker: MetaPicker,
                productdropdown: ProductDropdown,
                statusselect: StatusSelect,
                partnerselect: PartnerSelect,
                phoneinput: PhoneInput,
            }[field.type] || TextInput;

            if(name === 'country_id' || name === 'invoice_country_id') {
                field.options = countries
                    .filter(item => !field.onlyCurrentCountry || item.code === currentCountry)
                    .map((country) => ({
                    value: country.id,
                    label: country.name,
                }))
            }

            // if(name === 'zip' && field.validatetype === 'upslabelzip') {
            //         const country = countries.find(item => parseInt(item.id) === parseInt(values.country_id));
            //         if(country?.code === 'DE') {
            //             field.validatetype = 'upslabelzipDe';
            //         }
            //         if(country?.code === 'AT') {
            //             field.validatetype = 'upslabelzipAt';
            //         }
            // }

            let apiValidation;

            if(field.validatetype === 'api' && field.validationRoute) {
                // TODO: Can we invalidate the cache by country_id+zip?
                // simpleMemoize(async (value) => {
                apiValidation = simpleMemoize(async (value) => await fetch(field.validationRoute, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                        body: JSON.stringify(({
                            value,
                            key: field.name,
                            country_id: field.name === "invoice_zip" ? values.invoice_country_id : values.country_id,
                        })),
                    })
                        .then(result => result.json())
                        .then(result => {
                            if (result.is_blacklist) {
                                orderEntryDispatch({
                                    type: "setValue",
                                    key: "zipBlacklist",
                                    value: [
                                        ...(orderEntryState.zipBlacklist ?? []),
                                        {value, name: field.name},
                                    ],
                                });
                            }
                            if (!result.success) {
                                return result.message || field.validationErrorMessage || 'Invalid value';
                            }
                            return undefined;
                        }), field.name === "invoice_zip" ? values.invoice_country_id : values.country_id);
            } else {
                apiValidation = field.required ? validate[field.validatetype || field.type] || required : (['phone', 'serialnumber', 'problem_description', 'terminalId'].includes(field.name) ? validate[field.validatetype] : undefined);
            }

            return (
                <Field
                    name={name}
                    type={field.type === 'radiobig' ? 'radio' : field.type}
                    value={field.value}
                    min={field.min}
                    placeholder={field.placeholder}
                    onChange={field.onChange}
                    component={component}
                    validate={apiValidation}
                    field={field}
                    disabled={submitting || disabled}
                />
            );
    }
})

export default FormField;
